import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "./data";

export const PovStrip = () => (
  <div className="bg-[#093125] border-b border-[#F2EDE1]/10" data-testid="pov-strip">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
      <Reveal>
        <span className="eyebrow text-[#A6874E]">The Elevora Point of View</span>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="font-body text-lg md:text-2xl text-[#F2EDE1] max-w-2xl leading-snug" data-testid="pov-quote">
          Good growth isn't noise. It's the right decisions, carried through with care.
        </p>
      </Reveal>
    </div>
  </div>
);

export const Services = () => {
  return (
    <section id="services" className="bg-[#0B3D2E] py-24 md:py-36" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <span className="eyebrow text-[#A6874E]">What We Do</span>
        </Reveal>
        <div className="mt-8 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16 md:mb-20">
          <Reveal delay={0.1}>
            <h2
              className="font-grotesk font-bold uppercase text-[#F2EDE1] leading-[0.98] tracking-tight text-4xl sm:text-5xl md:text-6xl max-w-3xl"
              data-testid="services-heading"
            >
              One connected team. The work that moves you.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-xs md:text-sm leading-relaxed text-[#F2EDE1]/55 max-w-xs">
              Bring us the opportunity in front of you. We'll shape a considered mix of
              strategy, creative and digital execution around it.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-[#F2EDE1]/10">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={(i % 4) * 0.08} y={24}>
              <a
                href="#contact"
                data-testid={`service-cell-${s.id}`}
                className="group flex flex-col justify-between h-44 md:h-52 p-6 border-r border-b border-[#F2EDE1]/10 hover:bg-[#093125] transition-colors duration-500"
              >
                <span className="text-[10px] tracking-[0.25em] text-[#A6874E] font-medium">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex items-end justify-between gap-3">
                  <span className="text-[#F2EDE1] text-base md:text-lg font-medium leading-snug group-hover:text-[#A6874E] transition-colors duration-300">
                    {s.title}
                  </span>
                  <ArrowUpRight className="w-4 h-4 text-[#F2EDE1]/40 group-hover:text-[#A6874E] transition-colors duration-300 shrink-0" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
